import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router'; // Import RouterModule
import { BaseendPageComponent } from '../components/general/baseend-page/baseend-page.component';
import { LoaderComponent } from '../components/general/loader/loader.component';
import { TimeoutComponentComponent } from '../components/general/timeout-component/timeout-component.component';
import { CurrentcopPipe, CustomCurrencyPipe, RemoveMesesPipe, SumCurrencyPipe } from '../pipes/currentcop.pipe';
import { DetailSigningComponentGeneral } from '../components/general/detail-signing/detail-signing.component';
import { NewLayoutComponent } from '../refactoringComponents/new-layout/new-layout.component';
import { NewBannerComponent } from '../refactoringComponents/new-banner/new-banner.component';
import { NewDiscountBannerComponent } from '../refactoringComponents/new-discount-banner/new-discount-banner.component';
import { NewFooterComponentComponent } from '../refactoringComponents/new-footer-component/new-footer-component.component';
import { NewBaseComponentComponent } from '../refactoringComponents/new-base-component/new-base-component.component';
import { InfoBannerComponent } from '../components/general/info-banner/info-banner.component';
import { ModalPrivacityComponent } from '../refactoringComponents/modal-privacity/modal-privacity.component';
import { DocumentTypeComponent } from '../refactoringComponents/atoms/document-type/document-type.component';
import { DocumentNumberComponent } from '../refactoringComponents/atoms/document-number/document-number.component';
import { GeneralinputComponent } from '../refactoringComponents/atoms/generalinput/generalinput.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GeneralSelectComponent } from '../refactoringComponents/atoms/general-select/general-select.component';
import { GeneralCheboxComponent } from '../refactoringComponents/atoms/general-chebox/general-chebox.component';
import { InfoProiedadComponent } from '../cotizador/components/info-proiedad/info-proiedad.component';
import { AutoCompleteInputComponent } from '../refactoringComponents/atoms/auto-complete-input/auto-complete-input.component';
import { IcontextComponent } from '../refactoringComponents/atoms/Icontext/Icontext.component';
import { GeneralRadioComponent } from '../refactoringComponents/atoms/generalRadio/generalRadio.component';
import { GeneralDateComponent } from '../refactoringComponents/atoms/general-date/general-date.component';

import { ComponentsModule } from '../components/components.module';
import { GeneralCurrencyFormatterDirective } from '../directives/general-currency.directive';
import { StepperComponent } from '../refactoringComponents/atoms/stepper/stepper.component';
import { BottonContratoComponent } from '../refactoringComponents/atoms/bottonContrato/bottonContrato.component';
import { InfoContratoComponent } from '../cotizador/components/info-contrato/info-contrato.component';
import { InfoPlanBannerComponent } from "../cotizador/components/info-plan-banner/info-plan-banner.component";
import { WebMPlayerComponent } from './components/web-mplayer/web-mplayer.component';

@NgModule({
    declarations: [
        RemoveMesesPipe,
        CurrentcopPipe,
        SumCurrencyPipe,
        CustomCurrencyPipe,
        BaseendPageComponent,
        LoaderComponent,
        TimeoutComponentComponent,
        DetailSigningComponentGeneral,
        NewLayoutComponent,
        NewBannerComponent,
        NewDiscountBannerComponent,
        NewFooterComponentComponent,
        NewBaseComponentComponent,
        InfoBannerComponent,
        ModalPrivacityComponent,
        InfoProiedadComponent,
        InfoContratoComponent,
        //atoms
        DocumentTypeComponent,
        DocumentNumberComponent,
        GeneralinputComponent,
        GeneralSelectComponent,
        GeneralCheboxComponent,
        AutoCompleteInputComponent,
        IcontextComponent,
        GeneralRadioComponent,
        BottonContratoComponent,
        //directives
        GeneralCurrencyFormatterDirective
    ],
    imports: [
    FormsModule,
    StepperComponent,
    GeneralDateComponent,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    InfoPlanBannerComponent,
    WebMPlayerComponent
],
    exports: [
        RemoveMesesPipe,
        SumCurrencyPipe,
        CustomCurrencyPipe,
        CurrentcopPipe,
        BaseendPageComponent,
        LoaderComponent,
        DetailSigningComponentGeneral,
        TimeoutComponentComponent,
        NewLayoutComponent,
        NewBannerComponent,
        NewDiscountBannerComponent,
        NewFooterComponentComponent,
        NewBaseComponentComponent,
        InfoBannerComponent,
        ModalPrivacityComponent,
        InfoProiedadComponent,
        InfoContratoComponent,
        //atoms
        DocumentTypeComponent,
        DocumentNumberComponent,
        GeneralinputComponent,
        GeneralSelectComponent,
        GeneralCheboxComponent,
        AutoCompleteInputComponent,
        IcontextComponent,
        GeneralRadioComponent,
        AutoCompleteInputComponent,
        BottonContratoComponent,
        GeneralDateComponent,
        //CurrencyFormatterDirective
        GeneralCurrencyFormatterDirective
    ]
})
export class SharedModule { }
